import {GwtConfig} from "OK/GwtConfig";

let instance: CurrentUserCfg | null = null;

export interface ICurrentUserCfgData {
    uid: string;
    lang: string;
    bannerTargeting: Record<string, string | number>;
    replaceFeedBannerDelayMs: number,
    navFactoryReqTimeout: number,
    "share.urlPattern": string;
}

export class CurrentUserCfg extends GwtConfig<ICurrentUserCfgData> {
    urlPattern: RegExp | null = null;
    public static readonly REQUEST_TIMEOUT_MAX = 3000;

    constructor() {
        super('CurrentUser');
    }

    setData(data: ICurrentUserCfgData) {
        super.setData(data);
        this.urlPattern = null;
    }

    getUrlPattern() {
        if (!this.urlPattern) {
            this.urlPattern = new RegExp(this.data["share.urlPattern"]);
        }
        return this.urlPattern;
    }

    getUserId() {
        return this.data?.uid;
    }

    getLanguage() {
        if (this.data) {
            return this.data.lang;
        }
        return null;
    }

    getBannerParameters(): Record<string, string | number> | null {
        if (this.data) {
            return this.data.bannerTargeting || null;
        }
        return null;
    }

    getReplaceFeedBannerDelayMs() {
        return this.data.replaceFeedBannerDelayMs;
    }

    getGwtNavigationFactoryRequestTimeout() {
        return Math.min(this.data.navFactoryReqTimeout, CurrentUserCfg.REQUEST_TIMEOUT_MAX);
    }

    static getInstance(): CurrentUserCfg {
        if (!instance) {
            instance = new CurrentUserCfg();
        }
        return instance;
    }
}

export const getInstance = CurrentUserCfg.getInstance;
